import script from "./HeaderRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderRow.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderRow.vue?vue&type=style&index=0&id=21dec9fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21dec9fe"]])

export default __exports__